import { Product } from 'src/shared/types/product';

const getStatus = (product: Product) => {
  const allStagesDone =
    product?.detail?.lifecycle?.every((stage) => stage.status === 'done') ??
    false;

  if (allStagesDone) {
    return 'completed';
  }

  const isRelevantUpdate = product?.last_relevant_update?.relevant;
  const lastRelevantUpdateType = product?.last_relevant_update?.update_type;

  if (lastRelevantUpdateType === 'user-question') {
    return 'in-progress';
  }

  if (isRelevantUpdate) {
    if (lastRelevantUpdateType === 'block') {
      return 'action-required';
    }

    return 'new-update';
  }

  return 'in-progress';
};

export default getStatus;
